module.exports = {
  headline: 'Ethical Guidelines',
  index: [
    'Spotin\'s Ethical Guidelines',
    'References', 
  ],
  guidelines: `
    <p>
      Spotin is working with a range of suppliers of products, partnering users of the service (media), 
      as well as third party payment services. Payment service suppliers that in turn may use subsuppliers for 
      individual payment methods.
    </p>

    <p>
      All partnering users of Spotin will have to adhere to Spotin's ethical guidelines as well as guidelines 
      that are posed on Spotin through 3rd party supplying services, e.g. payment solution providers. 
    </p>

    <p>
      Spotin's Ethical Guidelines will be listed here shortly...
    </p>

    <h2 anchor>
     References
    </h2>
    <p>
      Below you can find links to guidelines by external parties that are effective to all suppliers and media 
      using Spotin.
    </p>

    <a href="https://cdn.klarna.com/1.0/shared/content/policy/ethic/en_gb/merchant.pdf">Klarna Ethical Guidelines</a>
  `,
};


// WEBPACK FOOTER //
// ./pages/content/ethicalGuidelines_EN.js